import type { SVGProps } from 'react'
const SvgSyJumpTime = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="m17.33 6.342-5.106 10.21a.25.25 0 0 1-.448 0L6.671 6.343a.5.5 0 0 1 .67-.671l4.212 2.105a1 1 0 0 0 .894 0l4.211-2.105a.5.5 0 0 1 .671.67"
		/>
		<path d="M14.5 17a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm-9 0a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z" />
	</svg>
)
export default SvgSyJumpTime
